import MainConnection from "./MainConnection";

export default {
  requestBanners: async function() {
    try {
      const requestURL = "/banners";
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
